import React from "react";
import PropTypes from "prop-types";
const TunesStandardisedIcon = ({
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color,
  title
}) => (
  <svg
    className={className}
    style={style}
    data-no-pointer={noPointer}
    width={width || size || 20}
    height={height || size || 20}
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
  >
    <title>{title}</title>
    <g fill="none" stroke="none" fillRule="evenodd">
      <path d="M0 0h20v20H0z" />
      <g fill={color || "var(--color-easil-gray-x-dark)"} fillRule="nonzero">
        <path d="M6 19a1 1 0 0 1-2 0v-7a1 1 0 0 1 2 0v7zM6 8a1 1 0 1 1-2 0V1a1 1 0 1 1 2 0v7zM16 19a1 1 0 0 1-2 0v-9a1 1 0 0 1 2 0v9zM16 6a1 1 0 0 1-2 0V1a1 1 0 0 1 2 0v5z" />
        <path d="M2 13a1 1 0 0 1 0-2h6a1 1 0 0 1 0 2H2zM12 7a1 1 0 1 1 0-2h6a1 1 0 0 1 0 2h-6z" />
      </g>
    </g>
  </svg>
);
TunesStandardisedIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default TunesStandardisedIcon;
